import moment from "moment";
import React, { useEffect, useState } from "react";
import RecurringPaymentsService from "../../../../../../../services/api/recurring-payments.service";
import Utilities from "../../../../../../../services/commonservice/utilities";
import Table2 from "../../../../../../templates/components/Table2";
import RecurringPlanButtonGroup from "../../../../../../../services/commonservice/recurring-button-group.utility";
const PaymentPlanList = (props) => {
  const [paymentPlanList, setPaymentPlanList] = useState();
  const [isLoader, setIsLoader] = useState(false)
  const [initialMessage, setInitialMessage] = useState(true)
  const paymentPlanLookup = () => {
    setIsLoader(true);
    let reqObj = {
      SearchTerm: "",
      isActive: true,
      isRegistered: true,
      SortField: "createdOn",
      Asc: false,
      PatientIds: props.patientId
    };
    setInitialMessage(false);
    RecurringPaymentsService.findRecurringPayments(reqObj)
      .then((res) => {
        if (res?.data?.data) {
          setPaymentPlanList(res?.data?.data);
        }
      })
      .catch((err) => console.log(err))
      .finally(() => setIsLoader(false));
  };

  useEffect(() => {
      paymentPlanLookup();
  }, []);

  const columns = [
    {
      id: "createdOn",
      Header: "Created On",
      accessor: (pp) => moment(pp.createdOn).format("MM-DD-YYYY")
    },
    {
      id: "invoiceNumber",
      Header: "Invoice Number",
      accessor: pp=> pp.invoiceNumber
    },
    {
      id: "transactionType",
      Header: "Type",
      accessor: (pp) => pp.transactionType === 1 ? "Payment Plan" : "Subscription"
    },
    {
      id: "totalPaymentsMade",
      Header: "Payments Made",
      accessor: (pp) => pp.totalPaymentsMade ? pp.totalPaymentsMade : 0
    },
    {
      id: "totalPaymentLeft",
      Header: "Payments Left",
      accessor: pp=> pp.totalPaymentLeft
    },
    {
      id: "paymentAmount",
      Header: "Payment Amount",
      accessor: (pp) => Utilities.toDollar(pp.paymentAmount)
    },
    {
      id: "totalAmountPaid",
      Header: "Paid",
      accessor: (pp) => Utilities.toDollar(pp.totalAmountPaid)
    },
    {
      id: "totalDueAmount",
      Header: "Open Balance",
      accessor: (pp) => Utilities.toDollar(pp.totalDueAmount)
    },
    {
      id: "totalAmount",
      Header: "Total",
      accessor: (pp) => Utilities.toDollar(pp.totalAmount)
    },
    {
      id: "action",
      Header: "Actions",
      disableSortBy: true,
      accessor: (pp) => {
        return <span className="row justify-content-end">
          <div className="col-auto btn-group">
                <RecurringPlanButtonGroup
                  buttonClass={'p-0 ps-1'}
                  initialData={pp}
                  //extraButton={extraButtons}
                  refresh={() => { setPaymentPlanList(); paymentPlanLookup() }}
                ></RecurringPlanButtonGroup>
            </div>
        </span>
      }
    },
  ]

  return (
    <>
      <div className="row d-flex g-4 justify-content-between p-3">
        <Table2 data={paymentPlanList} loading={isLoader} columns={columns} initialMessage={initialMessage} />
      </div>
    </>
  );
};

export default PaymentPlanList;
